// One timeout for every board call: a request that has not answered in 8 s is abandoned (and, for
// PostgREST, aborted) so a stalled connection can never hold a screen.

export const NET_TIMEOUT_MS = 8000;

export class TimeoutError extends Error {
  constructor(ms: number) {
    super(`network call timed out after ${ms} ms`);
    this.name = 'TimeoutError';
  }
}

/**
 * Runs `run` and resolves with its result, or rejects with TimeoutError after `ms`. The AbortSignal handed
 * to `run` fires on timeout; supabase-js query builders accept it via `.abortSignal()`. Auth calls ignore
 * it and are simply abandoned.
 */
export function timed<T>(run: (signal: AbortSignal) => PromiseLike<T>, ms: number = NET_TIMEOUT_MS): Promise<T> {
  const ac = new AbortController();
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      ac.abort();
      reject(new TimeoutError(ms));
    }, ms);
    Promise.resolve()
      .then(() => run(ac.signal))
      .then(
        (value) => { clearTimeout(timer); resolve(value); },
        (err: unknown) => { clearTimeout(timer); reject(err); },
      );
  });
}
